import React from "react";
import { chargerPdf } from "./api";
import { RondEleve, avatarDe, creerPhotos } from "../espace/RondEleve";
import { useChantiers } from "../lib/useChantiers";

/* La photo ou l'avatar choisi par la famille dans son app (Jen, 02.11.2026), vu par l'école :
   en tête de la fiche élève de la console, et sur la fiche de l'app école (la photo
   seulement). Rien pour un élève archivé, rien tant que le chantier « photos_eleves » est
   fermé. L'image se lit avec le compte de l'école (en-tête d'autorisation), en blob, une
   fois par version (`photo_maj` de la fiche). */
const { usePhoto } = creerPhotos((id, v) =>
  chargerPdf(`/eleves/${encodeURIComponent(id)}/photo?v=${encodeURIComponent(v)}`));

export const usePhotosOuvertes = () => !!useChantiers().photos_eleves;

/** La fiche porte-t-elle une photo ou un avatar visible ? */
export const aUnePhoto = (eleve, ouvert) =>
  !!(ouvert && eleve && !eleve.archive && (eleve.photo_maj || avatarDe(eleve.avatar)));

/* Le rond de la fiche. `avecAvatar` : la console montre aussi l'avatar ; l'app école, la
   photo seulement. Sans rien à montrer : `sinon` (la lettre de l'app école, rien dans la
   console). */
export const RondFiche = ({ eleve, taille = 64, avecAvatar = true, sinon = null, testId = "fiche-photo-eleve" }) => {
  const ouvert = usePhotosOuvertes() && !!eleve && !eleve.archive;
  const photo = usePhoto(ouvert ? eleve.id : "", ouvert ? String(eleve.photo_maj || "") : "");
  if (ouvert && photo) return <RondEleve prenom={eleve.prenom} photo={photo} taille={taille} testId={testId} />;
  if (ouvert && avecAvatar && avatarDe(eleve.avatar)) {
    return <RondEleve prenom={eleve.prenom} avatar={eleve.avatar} taille={taille} testId={testId} />;
  }
  return sinon;
};
